"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphicsComponentStore = void 0;
const initialize_graphics_component_1 = require("./graphics-components/initialize-graphics-component");
/**
 * @public
 * {@inheritDoc IGraphicsComponentStore}
 */
class GraphicsComponentStore {
    constructor() {
        this.graphicsComponents = new Map();
    }
    getComponent(componentId) {
        return this.graphicsComponents.get(componentId);
    }
    setComponent(component) {
        this.graphicsComponents.set(component.getCacheId(), component);
    }
    reinitializeGraphicsComponents(renderer) {
        this.graphicsComponents.forEach((gc) => {
            (0, initialize_graphics_component_1.initializeGraphicsComponent)(renderer, gc);
        });
    }
}
exports.GraphicsComponentStore = GraphicsComponentStore;
//# sourceMappingURL=graphics-component-store.js.map